import "../css/src/main.scss";

// ---------------------------------------------------------------------------
// Site header — mirrors master HeaderMain.vue inline script.
//   - Toggle `.fixed-scroll` on `.site-header` once scrolled past 50px
//   - Toggle `.show-on-mobile` on `#mobile-menu` when `.menu-mobile` clicked
// Implemented with jQuery to match the legacy snippet 1:1.
// ---------------------------------------------------------------------------
(function ($) {
  if (typeof $ === 'undefined') return;
  $(function () {
    $(window).scroll(function () {
      if ($(window).scrollTop() > 50) {
        $('.site-header').addClass('fixed-scroll');
      } else {
        $('.site-header').removeClass('fixed-scroll');
      }
    });
    $('.menu-mobile').click(function (e) {
      e.preventDefault();
      $('#mobile-menu').toggleClass('show-on-mobile');
    });
    // Close mobile menu when the close button (or its label/checkbox) is clicked.
    $(document).on('click', '.mobile-menu__close', function (e) {
      e.preventDefault();
      $('#mobile-menu').removeClass('show-on-mobile');
      $('#cellphonetoggle').prop('checked', false);
    });
  });
})(window.jQuery);
